import request from '@/utils/request'

/**
 * 绑定消息通知
 * @param data
 * @returns {*}
 */
export function sendMessage (data) {
  return request({
    url: '/api/an/worker/bindConnectId',
    method: 'post',
    params: data
  })
}

/**
 * 消息列表
 * @param data
 * @returns {*}
 */
export function getMessageList (data) {
  return request({
    url: '/api/an/worker/getMessageList',
    method: 'get',
    params: data
  })
}

/**
 * 标记已读
 * @param data
 * @returns {*}
 */
export function markMessage (data) {
  return request({
    url: '/api/an/worker/readMessage',
    method: 'post',
    data: data
  })
}

export function getMessageCount (data) {
  return request({
    url: '/api/an/worker/getMessageCount',
    method: 'get',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/message.js